import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledModalBody = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 30px;

	& > ${Text} {
		font-weight: 400;
		font-size: 16px;
		line-height: 18px;
		color: #ffffff;
		opacity: 0.75;
	}
`;

const StyledButtonsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	column-gap: 20px;
`;

export { StyledButtonsContainer, StyledModalBody };
